// plans.ts - Precios de los planes de Sistema Courier (USD/mes).
// Mismos valores que la tabla plans (database/migrations/20261008_update_plan_prices.sql).
// Enterprise es "desde": el precio real puede ser mayor según lo negociado.

export interface PlanInfo {
    name: string;
    price: number;
}

export const PLAN_INFO: Record<string, PlanInfo> = {
    trial: { name: 'Prueba', price: 0 },
    starter: { name: 'Starter', price: 75 },
    professional: { name: 'Professional', price: 199 },
    enterprise: { name: 'Enterprise', price: 449 },
};

export const planName = (planId?: string | null) =>
    (planId && PLAN_INFO[planId]?.name) || planId || '—';

export const planPrice = (planId?: string | null) =>
    (planId && PLAN_INFO[planId]?.price) || 0;
